import { fetchTimetableData } from "./fetchTimetableData";

export const timetableMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    action.type === 'timetable/toggleFilter' ||
    action.type === 'timetable/resetFilter'  ||
    action.type === 'timetable/setWeekRange' ||
    action.type === 'timetable/setDay'
  ) {
    store.dispatch(fetchTimetableData());
  }

  return result;
};